export function logException(exception) {
  console.error(exception);
}



// WEBPACK FOOTER //
// ./src/utils/logger.js